import { privateApi } from '../ApiService';
import {
    ManualTakeoverRequest,
    ManualTakeoverResponse,
    ManualActivationRequest,
    ManualActivationResponse,
} from './types';

const manualTakeover = async (
    conversationId: string,
    request: ManualTakeoverRequest = {},
): Promise<ManualTakeoverResponse> => {
    const response = await privateApi.post<ManualTakeoverResponse>(
        `leads-conversations/${conversationId}/agent-session/manual-takeover`,
        request,
    );
    return response.data;
};

const activateManually = async (
    conversationId: string,
    request: ManualActivationRequest,
): Promise<ManualActivationResponse> => {
    const response = await privateApi.post<ManualActivationResponse>(
        `leads-conversations/${conversationId}/agent-session/activate-manually`,
        request,
    );
    return response.data;
};

export const AgentSessionGateway = {
    manualTakeover,
    activateManually,
};
